import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import StoreDetailPage from './pages/StoreDetailPage';
import AdminUsersPage from './pages/admin/UsersPage';
import AdminRegionsPage from './pages/admin/RegionsPage';
import AdminStoresPage from './pages/admin/StoresPage';
import AdminAuditLogsPage from './pages/admin/AuditLogsPage';
import AdminAlertsPage from './pages/admin/AlertsPage';
import GoogleDashboardPage from './pages/admin/GoogleDashboardPage';
import AdminApiTokensPage from './pages/admin/ApiTokensPage';
import AppLayout from './components/layout/AppLayout';
import PrivateRoute from './components/auth/PrivateRoute';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <AppLayout>
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/stores/:storeId" element={<StoreDetailPage />} />
                  <Route path="/admin/users" element={<AdminUsersPage />} />
                  <Route path="/admin/regions" element={<AdminRegionsPage />} />
                  <Route path="/admin/stores" element={<AdminStoresPage />} />
                  <Route path="/admin/audit-logs" element={<AdminAuditLogsPage />} />
                  <Route path="/admin/alerts" element={<AdminAlertsPage />} />
                  <Route path="/admin/google-dashboard" element={<GoogleDashboardPage />} />
                  <Route path="/admin/api-tokens" element={<AdminApiTokensPage />} />
                </Routes>
              </AppLayout>
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
